import { useQueryClient } from 'react-query';
import { useRouteError } from 'react-router-dom';
import { GeneralErrorPage } from 'sonata-react-components';

import { Container, ErrorContainer, ErrorMessage, ErrorStack } from './GlobalCatch.styles';

function GlobalCatch() {
  const error: any = useRouteError();
  const queryClient = useQueryClient();

  const handleReloadClick = () => {
    queryClient.clear();
    window.location.reload();
  };

  return (
    <Container>
      <GeneralErrorPage id="global-catch-error">
        <GeneralErrorPage.Image />
        <GeneralErrorPage.Title />
        <GeneralErrorPage.SubTitle />
        <GeneralErrorPage.Actions
          retryConfig={{
            onRetry: handleReloadClick,
            showButton: true
          }}
        />
      </GeneralErrorPage>
      {import.meta.env.MODE !== 'production' ? (
        <ErrorContainer>
          {error ? <ErrorMessage>{error.message}</ErrorMessage> : null}
          {error && error.stack ? <ErrorStack>{error.stack}</ErrorStack> : null}
        </ErrorContainer>
      ) : null}
    </Container>
  );
}

export default GlobalCatch;
